<template>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Page Not Found</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              We're sorry, but the page you were looking for doesn't exist.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="$router.push('/')">Go to Home</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>    
  /**
  * Component to display a "File Not Found" message for unknown URLs.
  */
  export default {
    name: 'NotFoundComponent'
  }
  </script>
  
  <style scoped>
  </style>